import { render, staticRenderFns } from "./standardModel.vue?vue&type=template&id=15db982a&scoped=true"
import script from "./standardModel.vue?vue&type=script&lang=js"
export * from "./standardModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db982a",
  null
  
)

export default component.exports